(function() {
    'use strict';

    angular.module('blocks.pageslide', []);
})();